"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env_1 = require("./env");
function hostnameToInstanceName(hostname) {
    var formatted = (hostname || '').replace(/https?:\/\//gi, '');
    if (formatted.match('.sigmacloud.io')) {
        var formattedPieces = (formatted || '').replace('.sigmacloud.io', '').split('');
        formattedPieces[0] = formattedPieces[0].toUpperCase();
        formatted = formattedPieces.join('');
    }
    return formatted;
}
exports.hostnameToInstanceName = hostnameToInstanceName;
function instanceNameToHostname(name, https) {
    if (https === void 0) { https = true; }
    if (env_1.IS_DEV && name.match(/localhost/gi)) {
        return "http://" + name;
    }
    return (https ? 'https' : 'http') + "://" + name + ".sigmacloud.io";
}
exports.instanceNameToHostname = instanceNameToHostname;
function hostnameToInstancePath(hostname) {
    return hostnameToInstanceName(hostname).toLowerCase();
}
exports.hostnameToInstancePath = hostnameToInstancePath;
//# sourceMappingURL=instances.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/util/instances.js
// module id = S1lr
// module chunks = 0